import { Select } from "@mui/material";
import React, { Fragment, useContext } from "react";
import propTypes from "prop-types";

import { SessionContext } from "../../../../utility/useSession";
import { AssetLocation } from "../../../../logic/api";
import FloatingInputLabel from "../components/FloatingInputLabel";


const CarParkField: React.FunctionComponent<{
    label: string,
    value?: AssetLocation;
    carParkAccess: string;
    onChange: (value: AssetLocation) => void;
}> = (props) => {
    const session = useContext(SessionContext);


    let selectedCarParkId = -1;
    if (props.value != null) {
        selectedCarParkId = props.value.id;
    }
    return <FloatingInputLabel label={props.label}>
        <Select
            native
            style={{ width: "100%", maxWidth: 225, borderRadius: 5, padding: 5 }}

            value={selectedCarParkId}
            onChange={(e) => {
                if (session.current.site != null) {
                    const selectedCarPark = session.current.site.carParks.filter((cp) => {
                        return cp.id == e.target.value;
                    });

                    if (selectedCarPark.length > 0) {
                        props.onChange(selectedCarPark[0]);
                    }
                }
            }}
        >

            {session.current.site != null && session.current.site.carParks.map((item, i) => {
                if (props.carParkAccess.indexOf(`|${item.id}|`) != -1) {
                    return <option key={i} value={item.id} title={item.name}>{item.name}</option>;
                }
                return <Fragment key={i}></Fragment>
            })}

        </Select>
    </FloatingInputLabel>;
}
CarParkField.propTypes = {
    label: propTypes.string.isRequired,
    value: propTypes.any,
    onChange: propTypes.func.isRequired,
    carParkAccess: propTypes.string.isRequired,

}

export default CarParkField;